
export default function ThreeTierShowcase() {
  return (
    <section className="w-full bg-white py-16 md:py-24 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2
            className="text-[28px] md:text-[42px] font-bold text-[#1A1A1A] mb-3 md:mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Choose Your Grade
          </h2>
          <p
            className="text-[14px] md:text-[16px] text-[#666666] max-w-2xl mx-auto"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Every product comes in three performance tiers — from everyday DIY to elite professional applications
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Everyday Tier - Yellow */}
          <div className="bg-[#F2C612] rounded-lg p-6 md:p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-[#1A1A1A] rounded-full flex items-center justify-center mb-4 md:mb-6">
              <i className="ri-home-4-line text-[#F2C612] text-[24px] md:text-[32px]"></i>
            </div>
            <h3
              className="text-[22px] md:text-[28px] font-bold text-[#1A1A1A] mb-3 md:mb-4"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Everyday
            </h3>
            <p
              className="text-[14px] md:text-[16px] text-[#1A1A1A] leading-relaxed mb-4 md:mb-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Perfect for home DIY projects and light residential use. Reliable performance at an accessible price point.
            </p>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-start">
                <i className="ri-check-line text-[#1A1A1A] text-[18px] md:text-[20px] mr-2 mt-1"></i>
                <span className="text-[14px] md:text-[15px] text-[#1A1A1A]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Great for DIY enthusiasts
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#1A1A1A] text-[18px] md:text-[20px] mr-2 mt-1"></i>
                <span className="text-[14px] md:text-[15px] text-[#1A1A1A]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Budget-friendly option
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#1A1A1A] text-[18px] md:text-[20px] mr-2 mt-1"></i>
                <span className="text-[14px] md:text-[15px] text-[#1A1A1A]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Suitable for light use
                </span>
              </li>
            </ul>
          </div>

          {/* Contractor Grade Tier - Blue */}
          <div className="bg-[#2D7AC2] rounded-lg p-6 md:p-8 hover:shadow-xl transition-shadow duration-300 border-2 border-[#2D7AC2]">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center mb-4 md:mb-6">
              <i className="ri-tools-line text-[#2D7AC2] text-[24px] md:text-[32px]"></i>
            </div>
            <div className="flex items-center gap-2 mb-3 md:mb-4">
              <h3
                className="text-[22px] md:text-[28px] font-bold text-white"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Contractor Grade
              </h3>
              <span
                className="bg-white text-[#2D7AC2] text-[10px] md:text-[11px] font-bold px-2 py-1 rounded"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                POPULAR
              </span>
            </div>
            <p
              className="text-[14px] md:text-[16px] text-white leading-relaxed mb-4 md:mb-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              The go-to choice for professional tradespeople. Enhanced durability and performance for demanding commercial jobs.
            </p>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-start">
                <i className="ri-check-line text-white text-[18px] md:text-[20px] mr-2 mt-1"></i>
                <span className="text-[14px] md:text-[15px] text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Professional-grade quality
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-white text-[18px] md:text-[20px] mr-2 mt-1"></i>
                <span className="text-[14px] md:text-[15px] text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Enhanced durability
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-white text-[18px] md:text-[20px] mr-2 mt-1"></i>
                <span className="text-[14px] md:text-[15px] text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Faster working time
                </span>
              </li>
            </ul>
          </div>

          {/* Elite Pro Tier - Red */}
          <div className="bg-[#D42B2B] rounded-lg p-6 md:p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center mb-4 md:mb-6">
              <i className="ri-vip-crown-line text-[#D42B2B] text-[24px] md:text-[32px]"></i>
            </div>
            <h3
              className="text-[22px] md:text-[28px] font-bold text-white mb-3 md:mb-4"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Elite Pro
            </h3>
            <p
              className="text-[14px] md:text-[16px] text-white leading-relaxed mb-4 md:mb-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Premium formulation for the most demanding applications. Maximum strength, flexibility, and longevity.
            </p>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-start">
                <i className="ri-check-line text-white text-[18px] md:text-[20px] mr-2 mt-1"></i>
                <span className="text-[14px] md:text-[15px] text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Maximum strength &amp; flexibility
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-white text-[18px] md:text-[20px] mr-2 mt-1"></i>
                <span className="text-[14px] md:text-[15px] text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Extreme conditions rated
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-white text-[18px] md:text-[20px] mr-2 mt-1"></i>
                <span className="text-[14px] md:text-[15px] text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Longest lifespan guarantee
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
